import { createContext, useCallback, useState, type ReactNode } from "react";

import { UniversalBenchmarksModal } from "./universal-benchmarks-modal";

export const UniversalBenchmarksModalContext = createContext<{
  openUniversalBenchmarksModal: () => void;
} | null>(null);

export const UniversalBenchmarksModalProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <UniversalBenchmarksModalContext.Provider
      value={{
        openUniversalBenchmarksModal: useCallback(() => {
          setIsModalOpen(true);
        }, []),
      }}
    >
      {children}
      <UniversalBenchmarksModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </UniversalBenchmarksModalContext.Provider>
  );
};
